export const SERVICES_TAGS = {
    VULNERABILITY_EXCLUSIONS: 'VULNERABILITY_EXCLUSIONS',
};
